var _rect, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_136_776",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_136_776)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2052 8.98973L17.132 8.0147C17.1164 7.99873 17.0998 7.98369 17.0824 7.96966L11.078 2.51489C11.073 2.5104 11.068 2.50601 11.0629 2.50171C10.4337 1.96977 9.52007 1.96963 8.89069 2.50138C8.8856 2.50568 8.88058 2.51007 8.87565 2.51455L1.74374 8.98962C1.5144 9.19785 1.49727 9.55257 1.7055 9.78189C1.8162 9.90381 1.96828 9.96576 2.12093 9.96576C2.25542 9.96576 2.39037 9.91768 2.49777 9.82015L2.67985 9.65484V16.1614C2.67985 17.0892 3.43467 17.844 4.36248 17.844H15.6092C16.5369 17.844 17.2918 17.0892 17.2918 16.1614V9.67542L17.451 9.82003C17.6802 10.0283 18.035 10.0113 18.2433 9.78202C18.4515 9.55275 18.4345 9.19803 18.2052 8.98973ZM10.5515 16.7223H9.42909C9.43058 16.7056 9.43148 16.6887 9.43148 16.6716V13.3383H10.5491V16.6716C10.5491 16.6887 10.55 16.7056 10.5515 16.7223ZM16.17 16.1614C16.17 16.4706 15.9184 16.7223 15.6091 16.7223H11.6685C11.67 16.7056 11.6709 16.6887 11.6709 16.6716V12.7774C11.6709 12.4676 11.4197 12.2165 11.11 12.2165H8.8706C8.56083 12.2165 8.30972 12.4676 8.30972 12.7774V16.6716C8.30972 16.6887 8.31062 16.7056 8.31212 16.7223H4.36248C4.05321 16.7223 3.8016 16.4707 3.8016 16.1614V8.63639L9.62102 3.35294C9.82843 3.18283 10.1249 3.18283 10.3323 3.35302L16.17 8.65636V16.1614Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.b28f69df48a353e2f7de5bc448dc3118.svg";
export { ForwardRef as ReactComponent };